import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './styles/wrapper.scss';
import { connect } from 'react-redux';
import {
  SHOW_MODAL,
  HIDE_MODAL,
  MODAL_SUCCESS,
  MODAL_KEYBOARD,
  MODAL_UPDATE_EMAIL,
  MODAL_REINTENTO,
  MODAL_TERM_AND_COND,
  AAF_MODAL_ERROR,
  MODAL_PIN,
  MODAL_TIMEOUT_EVENT,
  MODAL_END_PLAYER2,
  AAF_MODAL_CHECK_EMAIL,
  MODAL_PROMOTION_TELMEX_TELCEL,
  MODAL_REGISTER_NET,
  MODAL_RECORD_SERIES_CONTENT,
  AAF_MODAL_SUCCESS,
  AAF_MODAL_SUCCESS_SUSCRIPTION,
  MODAL_ADDON,
  MODAL_INACTIVITY,
  AAF_MODAL_SUSPENDED_ACCOUNT,
  MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES,
  MODAL_KEEP_WATCHING,
  MODAL_2FA_LIMIT_PURCHASES,
  MODAL_2FA_LIMIT_ATTEMPTS,
  AAF_MODAL_QR_LOGIN,
  MODAL_MATCH_DETAIL,
  AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT,
  AAF_MODAL_CHANGE_AAF_TO_CLARO_TV,
  showModal, MODAL_DESCONEXION,
} from '../../actions/modal';
import Scrollable from '../Scrollable';
import FocusSettings from '../Focus/settings';
import Device from '../../devices/device';
import Utils, {showSpinner} from '../../utils/Utils';
import PipManager from '../../utils/pipManager/PipManager';
import Assets from './../../requests/apa/Asset';
import clarotv_logo from './../../components/Header/clarotv.png';
import {Button, cls} from '../../packages/components';
import deviceInfo from '../../devices/all/deviceInfo';
import {isValidURL} from "../../utils/isValidURL";
import { getPendingMatchModal, clearPendingMatchModal } from '../../containers/Mundial2026/FootballMatchDetail/pendingMatchModal.js';
import store from 'src/store';
import logger from 'src/utils/logger/logger';


class ModalWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.defaultFocusableSelector = FocusSettings.selector;
    this.prevElementFoucused = { target: null, className: 'modalPrevElementFocused' };
    this.isFirstFocus = true;
    this.buttonsAlign = props.buttonsAlign ? props.buttonsAlign : 'horizontal';
    this.extraClass = props.extraClass ? props.extraClass : '';
    this.keys = Device.getDevice().getKeys();
    this.willUnFocusHandler = this.willUnFocusHandler.bind(this);
    this.handleBackKey = this.handleBackKey.bind(this);
    this.defaultItem = 'modal-default-item';
    this.device = Device.getDevice() && Device.getDevice().getPlatform();
    this.systemDevice = Device.getDevice() && Device.getDevice().getSystem();
    this.timeoutId = props.timeoutId;
    this.filterClass = 'modal-button-documents-filter';
    this.filterButton0 = 'modal-filter-button-0';
    this.filterButton0Aux = 'music-filter-btn-0';
    this.idButtonYellow = 'id_yellow_button';
    this.handleClick = props.handleClick;

    //FIX android para no mostrar PIP en modales
    PipManager.closePIP(Device, false);
  }
  willUnFocusHandler({ target }) {
    if (this.isFirstFocus) {
      if (!this.props.alwaysEnabled) {
        target.classList.add(this.prevElementFoucused.className);
      }
      this.prevElementFoucused.target = target;
      this.isFirstFocus = !this.isFirstFocus;
    }
  }

  closeApp = () => {
    logger.warn('closeApp - Attempting to close the app...');
    this.systemDevice.exit();
  }

  handleBackKey(e) {

    if (!Utils.isNotificationHide() && Utils.modalType() !== MODAL_INACTIVITY) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if(Utils.modalType() === AAF_MODAL_SUSPENDED_ACCOUNT) {
      if (this.device === 'samsung') {
        this.closeApp();
        e.preventDefault();
        e.stopPropagation();
        return;
      } else {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }

    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;


    const blockedPopUpList = [MODAL_POLITICAS, MODAL_TERMINOS_Y_CONDICIONES, MODAL_POLITICA_DE_PRIVACIDAD];
    const freePassKeys = [ 'OK', 'UP' , 'DOWN']

    if(blockedPopUpList.includes(Utils.modalType()) && !(freePassKeys.includes(currentKey))) {
      e.preventDefault();
      e.stopPropagation();

      const {callbackWhenBack = ()=>{}} = this.props

      if (currentKey === 'BACK')  callbackWhenBack();
      if (currentKey !== 'YELLOW') return;
    }

    logger.debug('Listening ModalWrapper, currentKey:', currentKey);
    const customizedButtonReturn = 'modal-button-return';

    if (this.props && this.props.timer && typeof this.props.timer == 'function') {
      this.props.timer();
    }
    if(Utils.isModalEpgVersionOpen() && currentKey !== 'BACK'){
      return;
    }

    const {onkeyDown = ()=>{}, onkeyUp = ()=>{}} = this.props || {};

    switch (currentKey) {
      case 'BLUE':
        if(Utils.isModalCallCenterOpen()) return;

        e.preventDefault();
        e.stopPropagation();
        if (Utils.modalType() === MODAL_END_PLAYER2) {
          if (typeof this.props.callbackWhenBack === 'function') {
            this.props.callbackWhenBack();
          }
          this.props.handleClose(e);

        }
        if (Utils.modalType() === MODAL_ADDON) {
          logger.debug("Modal on")
          this.props.callblueWhenBlue(e);


        }
        break;
      case 'RED':
        if(Utils.modalType() === MODAL_RECORD_SERIES_CONTENT){
          this.props && (typeof this.props.redAction === 'function') && this.props.redAction(e);
          e.preventDefault();
          e.stopPropagation();
        }
        if(!this.props.deleteButtonActive){
          e.preventDefault();
          e.stopPropagation();
        }
        break;
      case 'YELLOW':
        if(Utils.modalType() === MODAL_REGISTER_NET){
          this.props.buttons[3].props.onClick();
          return;
        }
        if(Utils.modalType() === MODAL_PROMOTION_TELMEX_TELCEL){
          this.props.buttons[0].props.onClick();
          return;
        }
        if(Utils.modalType() == MODAL_2FA_LIMIT_PURCHASES ||
          Utils.modalType() == MODAL_2FA_LIMIT_ATTEMPTS){
          return;
        }
        if (
          typeof this.props.yellowAction === 'function'
        ) {
          this.props.yellowAction(e);
        }
        break;
      case 'BACK':
        if (Utils.modalType() === AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT) {
          this.props.callbackWhenBack && this.props.callbackWhenBack();
          e.stopPropagation();
          e.preventDefault();
          return;
        }

        if(Utils.modalType() === AAF_MODAL_CHANGE_AAF_TO_CLARO_TV || Utils.modalType() === MODAL_DESCONEXION){
          e.preventDefault()
          e.stopPropagation();
          return;
        }

        this.props.restorePendingMatchDetailModal();
        if (Utils.modalType() === MODAL_KEEP_WATCHING) {
          this.props.handlerBack && this.props.handlerBack();
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        if(Utils.modalType() === MODAL_INACTIVITY){
          this.props.backRCU();
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if(Utils.modalType() === MODAL_TERM_AND_COND || Utils.modalType() === MODAL_PROMOTION_TELMEX_TELCEL ){
          this.props.colorButtons[0].props.onClick();
          return;
        }
        if(Utils.modalType() === MODAL_REGISTER_NET){
          this.props.buttons[3].props.onClick();
          return;
        }

        if(Utils.modalType() === AAF_MODAL_QR_LOGIN){
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if(Utils.modalType() ===  MODAL_PIN) {
          const { cancelCallBack = () => {}} = this.props;
          cancelCallBack();
        }

        if(Utils.modalType() === AAF_MODAL_CHECK_EMAIL ){
          this.props.buttons[0].props.onClick();
        }
        if (
          Utils.modalType() === MODAL_TIMEOUT_EVENT ||
          ((Utils.modalType() === MODAL_SUCCESS ||
              Utils.modalType() === MODAL_KEYBOARD) &&
            !Utils.isModalHide() &&
            Utils.modalFrom() === 'payment')
        ) {
          if (
            this.props.buttons[0] &&
            typeof this.props.buttons[0].props.onClick == 'function'
          ) {
            this.props.buttons[0].props.onClick();
          }
        }

        if ((Utils.modalType() === AAF_MODAL_SUCCESS || Utils.modalType() === AAF_MODAL_SUCCESS_SUSCRIPTION) && this.props && this.props.backclose){
          const is2FA = (this.props.children && this.props.children.props && this.props.children.props.data && this.props.children.props.data.is2FA) ? true : false;
          !is2FA && this.props.buttons[0].props.onClick();
        }

        if (typeof this.props.callbackWhenBack === 'function') {
          this.props.callbackWhenBack();
        }
        if (Utils.modalType() !== MODAL_UPDATE_EMAIL) {
          if (Utils.modalType() === MODAL_REINTENTO) {
            this.props.handleBackKey(e);
          } else if (
            Utils.modalType() === MODAL_TERM_AND_COND ||
            Utils.modalType() === AAF_MODAL_ERROR
          ) {
            if (
              this.props &&
              this.props.handleBackKey &&
              typeof this.props.handleBackKey == 'function'
            ) {
              this.props.handleBackKey(e);
            } else {
              this.props.handleClose(e);
            }
          } else {
            this.props.handleClose(e);
          }
        }
        if (
          this.props.extraClass &&
          this.props.extraClass.includes('pinKeyboard') &&
          this.props.buttons &&
          this.props.buttons[0] &&
          this.props.buttons[0].content &&
          this.props.buttons[0].content.includes('Cancelar')
        ) {
          this.props.buttons[0].props.onClick && this.props.buttons[0].props.onClick(e);
        }
        if (
          this.props &&
          typeof this.props == 'object' &&
          this.props.hasOwnProperty('fromEndPlayer') &&
          this.props.fromEndPlayer
        ) {
          PipManager.resizePIPendPlayer();
        } else PipManager.resizePIP();
        break;
      case 'EXIT':
        if(Utils.modalType() === AAF_MODAL_SUSPENDED_ACCOUNT) {
          this.closeApp();
          e.preventDefault();
          e.stopPropagation();
        }
        break;
        case 'DOWN':
        if(Utils.modalType() === MODAL_TERM_AND_COND){
          document.getElementsByClassName(customizedButtonReturn)[0].blur();
          document.getElementsByClassName('modal-content')[0].scrollTop += 25;
        }
        onkeyDown();
        break;
      case 'UP':
        if(Utils.modalType() === MODAL_TERM_AND_COND) {
          document.getElementsByClassName(customizedButtonReturn)[0].focus();
          document.getElementsByClassName('modal-content')[0].scrollTop += -25;
        }
        onkeyUp();
        break;
      case 'LEFT':
      case 'RIGHT':
      case 'OK':
      case 'ZERO':
      case 'ONE':
      case 'TWO':
      case 'THREE':
      case 'FOUR':
      case 'FIVE':
      case 'SIX':
      case 'SEVEN':
      case 'EIGHT':
      case 'NINE':
        break;
      case 'CH_UP':
      case 'CH_DOWN':
        if(Utils.modalType() === MODAL_INACTIVITY){
          return;
        }

        const modalNotToClose = [MODAL_UPDATE_EMAIL, MODAL_PIN];
        if (modalNotToClose.indexOf(Utils.modalType()) === -1) {
          this.props.handleClose(e);
          PipManager.resizePIP();
        }
        break;
      default:
        e.preventDefault();
        e.stopPropagation();
    }
  }

  componentDidMount() {
    this.addEventListener();
    const isMusic = this.props.isMusic;
    const nameModalIsCountriesCitiesInMusic = this.props.nameModal === 'cities' || this.props.nameModal === 'countries';
    !isMusic && window.SpatialNavigation.focus('modal-area');
    !isMusic && window.SpatialNavigation.makeFocusable();

    if (typeof this.props.onOpen === 'function') {
      this.props.onOpen();
    }

    const input = document.getElementById(this.idButtonYellow);
    if(input) {
      input.blur();

      const inputButtonFilter0 = document.getElementById(this.filterButton0);
      if(inputButtonFilter0){
        Utils.setInitialFocusChangeTime(inputButtonFilter0, 0)
      }
    }

    //Regresa el foco al modal para el filtro de ciudades o países en Claro Música
    isMusic
    && nameModalIsCountriesCitiesInMusic
    && Utils.setInitialFocusChangeTime(`.${this.filterButton0Aux}`, 500)

  }

  addEventListener = () => {
    if (Utils.isSonyBraviaOperaBrowser()) {
      window.addEventListener('sn:willunfocus', this.willUnFocusHandler);
      window.addEventListener('keydown', this.handleBackKey, true);
    } else {
      document.addEventListener('sn:willunfocus', this.willUnFocusHandler);
      document.addEventListener('keydown', this.handleBackKey, true);
    }
  };

  removeEventListener = () => {
    if (Utils.isSonyBraviaOperaBrowser()) {
      window.removeEventListener('sn:willunfocus', this.willUnFocusHandler);
      window.removeEventListener('keydown', this.handleBackKey, true);
    } else {
      document.removeEventListener('sn:willunfocus', this.willUnFocusHandler);
      document.removeEventListener('keydown', this.handleBackKey, true);
    }
  };

  componentWillUnmount() {
    this.removeEventListener();
    const { className, target } = this.prevElementFoucused;
    if (target) {
      const classToFocus = target.classList.contains('modal-button')
        ? this.defaultFocusableSelector
        : `.${className}`;
      window.SpatialNavigation.focus(classToFocus);
      this.prevElementFoucused.target.classList.remove(className);
    } else {
      window.SpatialNavigation.focus(this.defaultFocusableSelector);
    }
    if(this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  renderAAFButtons(buttons = []) {
    const _this = this;
    let keyId = 0;
    return buttons.map(button => {
      keyId++;
      const extraClass = button.extraClass ? button.extraClass : '';
      const variant = button.props.variant ? button.props.variant : 'primary';
      return (
        <Button
            type="button"
            variant={variant}
            key={button.content + keyId}
            {...button.props}
            className={`focusable ${button.props.className} ${extraClass} ${this.device}-device ${
              button.selected ? this.defaultItem : ''
              }`}
        >
          {button.content}{' '}
          {(button.selected && !button.props.isRegisterNet) && <i className="fa fa-check" aria-hidden="true" />}
          {button.props.imgSrc && (
            <img
              alt={button.props.imgAlt}
              id={button.props.imgId}
              src={button.props.imgSrc}
              className={button.props.imgClassName}
            />
          )}
        </Button>
      );
    });
  }

  handleMouseEnter = (e) => {
    Utils.handleMouseEnter(e)
  }

  renderButtons(buttons = []) {
    const _this = this;
    return buttons.map((button, num)  => {
      const extraClass = button.extraClass ? button.extraClass : '';
      return (
        <a
          style={button.styles}
          className={`modal-button focusable ${extraClass} ${
            button.selected ? this.defaultItem : ''
          }`}
          key={`${button.content}-${num}`}
          {...button.props}
          href="javascript:void(0)"
          id = {Math.random() * 10}
          onMouseEnter={(e) => this.handleMouseEnter(e)}
        >
          {button.content}{' '}
          {button.selected && <i className="fa fa-check" aria-hidden="true" />}
          {button.props.imgSrc && (
            <img
              alt={button.props.imgAlt}
              id={button.props.imgId}
              src={button.props.imgSrc}
              className={button.props.imgClassName}
            />
          )}
        </a>
      );
    });
  }

  renderOptionalChild(propName, content) {
    const key = propName.split('-')[0];
    if (!key || this.props[key] === undefined) return null;
    return (
      <div key={propName} className={`modal-${propName}`}>
        {content}
        {this.props.subtitle && propName === 'content' && <span className ="modal-content_subtitle">{this.props.subtitle}</span>}
      </div>
    );
  }

  getHtml(htmlString = '') {
    let html = htmlString && htmlString.replace(/(<*script )/gi, 'illegalscript');
    if (!html || html.trim() === '') {
      html = '&nbsp;';
    }
    return { __html: html };
  }

  renderColorButtons(buttons = []) {
    const _buttons = buttons.map(button => {
      const buttonClassName = button.props.className ? button.props.className : '';
      const id = button.props.id ? button.props.id : undefined;
      return (
        <Button
        style={button.styles}
        className={`${buttonClassName} focusable`}
        key={button.content}
        onClick={button.props.onClick}
        id = {id ? id : Math.random() * 10}
        handleMouseEnter = {button.props.handleMouseEnter}
      >
        <span className={`modal-button-colors ${button.props.color}`} />
        {button.props.imgSrc && (
          <img
            alt={button.props.imgAlt}
            id={button.props.imgId}
            src={button.props.imgSrc}
            className={button.props.imgClassName}
          />
        )}
        <div className="modal-text-button-return">{button.content}</div>{<div className="modal-position-default-arrow" />}
      </Button>
      );
    });
    return (
      <div className={'modal-color-buttons'} autoFocus>
        {_buttons}
      </div>
    );
  }

  showHeader() {
    const headerLogo = this.props.imgLogo !== "" ? Assets.get(this.props.imgLogo) : Assets.get('logo_clarotv', clarotv_logo);
    const widthHeaderLogo = this.props.sizeLogo.width !== "" ? this.props.sizeLogo.width : "160"; // Pedirlo de APA también
    const heightHeaderLogo = this.props.sizeLogo.height !== "" ? this.props.sizeLogo.height : "33"
    const logo = this.props.showLogo ? (<div className="modal-logo">
        <img width={widthHeaderLogo} height={heightHeaderLogo} src={headerLogo} alt="claroTv logo" />
      </div>) : null;
    const titleNet = this.props.showNetTitle ? (<div className="modal-register-net-title">{this.props.netTitle}</div>) : null;
    const colorButtons = this.props.colorButtons ? this.renderColorButtons(this.props.colorButtons) : null;
    return (
      <div className='modal-header'>
        {logo}
        {colorButtons}
        {titleNet}
      </div>
    );
  }

  showFooterRegisterNet() {
    const footerRegisterNet = <div className="modal-footer-register-net-text">{this.props.footerText}</div>;
    return (
      <div className='modal-footer-register-net'>
        {footerRegisterNet}
      </div>
    );
  }

  render() {
    const content = [];
    const type = typeof this.props.content;
    const isAssetValid = isValidURL(this.props.asset)
    if(isAssetValid){
      content.push(
        this.renderOptionalChild('asset', <img src={this.props.asset} alt={this.props.asset} />)
      );
    } else {
      content.push(
        this.renderOptionalChild('asset', <h2>{this.props.asset}</h2>)
      )
    }
    content.push(
      this.renderOptionalChild(
        'title',
        <h3 dangerouslySetInnerHTML={this.getHtml(this.props.title)} />
      )
    );
    const replaces = this.props.replaces;
    // Optimizar el replace, independiente de si viene o no un mensaje largo (en texto)
    // let msg = "Al confirmar, el cargo de S/ 239.5023 se cargará. hallo@hotmail.com en. tu Línea móvil Claro S. A. B. C. V."; // hardcode testing
    let msg = this.props.content + ' ';
    let urlRegExp = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)/;
    let containsMail = false;
    let dataMail;
    let acronymRegularExpresion = /\b[A-Z][.]\s*[a-z]*\s*/g;
    let moneyRegularExpresion = /\s((\$|R[$]|Gs.|(\US\$)|U[$]S|B[/].?|S[/].?|R$|₡|Q|C[$]|RD[$])(\s*\d+)?([.|,])?(\d+)?)|((\s*\d+)?([.|,])?(\d+)?(\¢|₲))/g;
    let moneyRegularExpresionNormaly = /[0-9][.][0-9]/;
    let acronym = null;
    let money = null;

    if (type == 'string' && msg.includes('.') && msg.length > 60 && !urlRegExp.test(msg)) {
      containsMail = Utils.checkIfEmailInString(msg);
      //Primero validamos si existe un email dentro del msg
      if (containsMail) {
        // Extraemos el email y lo guardamos temporalmente
        dataMail = Utils.extractEmails(msg);
        // Reemplazamos por un valor generico para que el resto del proceso haga los saltos de linea si contiene puntos
        msg = msg.replace(/[a-zA-Z0-9-_.]+@[a-zA-Z0-9-_.]+/, '{@EMAIL}');
      }
      if (acronymRegularExpresion.test(msg)) {
        acronym = msg.match(acronymRegularExpresion).join('');
        msg = msg.replace(acronym, '{@ACRONYM}');
      }

      if (moneyRegularExpresion.test(msg)) {
        money = msg.match(moneyRegularExpresion);
        money.forEach(function(moneyData){
          msg = msg.replace(moneyData, '{@MONEY}');
        });

      } else if (moneyRegularExpresionNormaly.test(msg)) {
        money = msg.match(moneyRegularExpresionNormaly)[0];
        msg = msg.replace(money, '{@MONEY}');
      }

      // Antes del reemplazo, se hacen los saltos de línea
      msg = msg.split('.').join('. <br/>');

      // Si el modal no contiene replaces pero el mensaje contiene email, se reeemplaza el valor de mail.
      if (containsMail) {
        // Cerificamos que exista el valor y sea un array para poder hacer split
        if (dataMail && dataMail instanceof Array) {
          msg = msg.replace('{@EMAIL}', dataMail.join(''));
        }
      }
      if (acronym !== null) {
        msg = msg.replace('{@ACRONYM}', acronym);
      }
      if (money !== null) {
        money.forEach(function(moneyData){
          msg = msg.replace('{@MONEY}', moneyData);
        });
      }

      // Luego el reemplazo
      if (replaces) {
        for (const i in replaces) {
          msg = msg.replace(i, replaces[i]);
        }
      }
      content.push(
        this.renderOptionalChild(
          'content',
          <div dangerouslySetInnerHTML={this.getHtml(msg)} />
        )
      );
    } else {
      // Si le length no es demasiado, pero aún viene con replaces
      if (replaces) {
        for (const i in replaces) {
          msg = msg.replace(i, replaces[i]);
        }
      }
      content.push(
        this.renderOptionalChild(
          'content',
          <div dangerouslySetInnerHTML={this.getHtml(msg)} />
        )
      );
    }

    if (this.props.children)
      content.push(
        <div className={cls(`modal-children`, (this.props && this.props.childrenClassName ? this.props.childrenClassName : ''))} key={this.props.children}>
          {this.props.children}
        </div>
      );
    if(this.props.aafNewStyle){
      content.push(
        this.renderOptionalChild(
          `buttons-${this.buttonsAlign} ${this.extraClass}`,
          this.renderAAFButtons(this.props.buttons)
        )
      );
    }else{
      content.push(
        this.renderOptionalChild(
          `buttons-${this.buttonsAlign} ${this.extraClass}`,
          this.renderButtons(this.props.buttons)
        )
      );
    }

    return (
      <div className={`modal-overlay ${this.device} ${this.props.classNameComponent}`} id="modal-overlay-main">
        {this.props.aafNewStyle ? (
          this.showHeader()
        ) : null
        }
        {this.props.showFooterRegisterNet ? (
          this.showFooterRegisterNet()
        ) : null
        }
        {this.props.scrollable ? (
          <Scrollable
            className={`modal-container ${this.props.className} scroll`}
            height="650px"
          >
            {content}
          </Scrollable>
        ) : (
          <div className={`modal-container ${this.props.className}`}> {content} </div>
        )}
      </div>
    );
  }
}

ModalWrapper.propTypes = {
  asset: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  replaces: PropTypes.object,
  buttons: PropTypes.array,
  className: PropTypes.string,
  aafNewStyle: PropTypes.bool,
  showLogo: PropTypes.bool,
  sizeLogo: PropTypes.object,
  imgLogo: PropTypes.string,
};

ModalWrapper.defaultProps = {
  className: '',
  replaces: null,
  aafNewStyle: false,
  showLogo: true,
  sizeLogo: {
    height: "",
    width: ""
  },
  imgLogo: "",
};

const closeable = ModalComponent => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.handleClose = this.handleClose.bind(this);
      this.handleSecondModal = this.handleSecondModal.bind(this);
    }

    restorePendingMatchDetailModal = () => {

            logger.debug('Paco: restorePendingMatchDetailModal - this.props:', this.props);

            if (!this.props.playFromMatchDetail) {

                logger.debug('Paco: playFromMatchDetail es falso o vacío');

                return false;

            }

            const pending = getPendingMatchModal();

            if (!pending) {

                logger.debug('Paco: No hay pending');

                return false;

            }

            clearPendingMatchModal();

            showSpinner(true);

            setTimeout(() => {

                store.dispatch(showModal({ modalType: MODAL_MATCH_DETAIL, modalProps: pending }));

            }, 100);

            return true;

        };


    handleClose(e, cb) {
      if(Utils.modalType() !==  MODAL_PIN) {this.restorePendingMatchDetailModal();}
      e && e.preventDefault();
      if (
        this.props &&
        typeof this.props == 'object' &&
        this.props.hasOwnProperty('fromEndPlayer') &&
        this.props.fromEndPlayer
      ) {
        PipManager.resizePIPendPlayer();
      } else PipManager.resizePIP();

      document.querySelector('.focus-container').style.display = 'none';

      this.props.dispatch({ type: HIDE_MODAL });
      if (typeof cb === 'function') return cb(this);

    }
    handleSecondModal(e, modal, props) {
      e.preventDefault();
      this.props.dispatch({ modalType: modal, type: SHOW_MODAL, modalProps: props });
    }
    render() {
      return (
        <ModalComponent
          {...this.props}
          handleClose={this.handleClose}
          handleSecondModal={this.handleSecondModal}
          restorePendingMatchDetailModal={this.restorePendingMatchDetailModal}
        />
      );
    }
  };
};
export const withOnClose = component => connect()(closeable(component));
export default withOnClose(ModalWrapper);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalWrapper.jsx